import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type {
  GetAgentInstructionChecksToolInput,
  GetAgentInstructionChecksToolOutput,
} from "@repo/app-types/entities/configurationAgent";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

/** Count how many checks failed across every instruction section. */
function countFailedChecks(
  checks: GetAgentInstructionChecksToolOutput["checks"],
): number {
  let failed = 0;
  for (const section of Object.values(checks) as Record<
    string,
    { status: "pass" | "fail" }
  >[]) {
    for (const check of Object.values(section)) {
      if (check.status === "fail") {
        failed += 1;
      }
    }
  }
  return failed;
}

export const GetAgentInstructionChecksTool: ToolComponent<
  GetAgentInstructionChecksToolInput,
  GetAgentInstructionChecksToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Checking instruction sections...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while checking the instruction sections";
    }

    // A proposal test (candidate_draft present) reads as "Tested proposed
    // changes"; a plain saved-draft check reads as "Checked instruction sections".
    const isProposal = props.output.candidate_draft != null;
    const subject = isProposal
      ? "Tested proposed changes"
      : "Checked instruction sections";
    const failed = countFailedChecks(props.output.checks);
    if (failed === 0) {
      return `${subject} — all checks passed`;
    }
    return `${subject} — ${failed} ${failed === 1 ? "issue" : "issues"} found`;
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
